import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ManualReturnContext, TicketReturnContext } from "../../aiTickets.types";
import { ApiRoutesSupportTickets } from "../../constants/enums";

export const requestManualReturnContext = async (
  whatsappConversationId: string,
): Promise<ManualReturnContext> => {
  return await instance.get(
    buildUrl(ApiRoutesSupportTickets.Tickets, "manual-return", "context"),
    { params: { whatsappConversationId } },
  );
};

export const requestManualReturnOrderContext = async (
  whatsappConversationId: string,
  orderId: string,
): Promise<TicketReturnContext> => {
  return await instance.get(
    buildUrl(ApiRoutesSupportTickets.Tickets, "manual-return", "order-context"),
    { params: { whatsappConversationId, orderId } },
  );
};

export interface CreateManualReturnBody {
  whatsappConversationId: string;
  orderId: string;
  returnItems: { barcodeId: string; quantity: number }[];
  returnReason: string;
  returnDescription?: string;
  evidenceMessageIds?: string[];
  returnMobileMoneyNumber?: string;
}

// One call, and it creates the return — no ticket in between.
export const requestCreateManualReturn = async (
  body: CreateManualReturnBody,
): Promise<void> => {
  return await instance.post(
    buildUrl(ApiRoutesSupportTickets.Tickets, "manual-return"),
    body,
  );
};
